<div class="theme-winter no-bg">
    <router-outlet></router-outlet>
  </div>
